import styled from 'styled-components';
import FlexBox from './FlexBox';
import zIndexScale from '../utils/zIndexScale';

export const NavUl = styled(FlexBox.withComponent('ul'))`
  flex: 1 1 auto;
  flex-wrap: nowrap;
  list-style: none;
  margin: 0;
  padding: 0 !important;
  // box-shadow: ${({ theme }) => theme.boxShadow};
`;

export const NavLi = styled.li`
  display: flex;

  & > * {
    color: #bcbcbc;
    align-items: center;
    display: flex;
    height: 100%;
    width: 100%;
  }

  &.trunk {
    border-left: 1px solid #5b5b5b;
    border-right: 1px solid #232323;
    box-shadow: -1px 0 0 #232323, 1px 0 0 #5b5b5b;
  }

  &.nav-item-identification {
    line-height: 48px;
    margin-left: 15px;
    padding: 0 20px;
  }
`;

export const NavList = styled(NavUl)`
  background-color: #333;
  flex-wrap: wrap;
  position: absolute;
  top: 48px;
  width: fit-content;
  height: fit-content;
  z-index: ${zIndexScale.nav};
`;

export const NavListItem = styled(NavLi)`
  display: flex;

  /* stylelint-disable no-descending-specificity */
  a {
    display: flex;
    color: #fff;
    font-size: 13px;
    height: 100%;
    width: 100%;
    padding: 0 16px;
    line-height: 34px;
  }

  & a:hover {
    color: ${({ theme }) => theme.highlight};
    cursor: pointer;
    background: rgba(255, 255, 255, 0.04);
  }
  /* stylelint-enable */
`;
